import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { getClientInfoForm } from 'src/app/forms/superAdminForms';
import { DetailFormDraft, IClientInfo, IClientInfoDraft, ISelectElement } from 'src/app/models';
import { DetailFormComponent } from 'src/app/shared/detail-form/detail-form.component';
import { FormActionsComponent } from 'src/app/shared/form-actions/form-actions.component';

@Component({
  selector: 'app-client-info-form',
  templateUrl: './client-info-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DetailFormComponent, FormActionsComponent],
})
export class ClientInfoFormComponent {
  readonly clientInfo = input<IClientInfo | null>(null);
  readonly townIds = input<number[]>([]);
  readonly towns = input<ISelectElement[] | null>(null);
  readonly saving = input(false);
  readonly edit = model(false);
  readonly save = output<IClientInfoDraft>();
  readonly cancelled = output();

  readonly draft = new DetailFormDraft<IClientInfoDraft>(() => ({
    ...this.clientInfo(),
    logoOnReservations: !!this.clientInfo()?.logoOnReservations,
    logoOnMap: !!this.clientInfo()?.logoOnMap,
    townIds: this.townIds(),
  }));
  readonly fields = computed(() => getClientInfoForm(this.draft.value(), this.edit(), this.towns()));
  readonly isValid = computed(() => {
    const draft = this.draft.value();
    const phoneNumberValid = draft.phoneNumber === null || draft.phoneNumber === undefined || draft.phoneNumber >= 0;
    return phoneNumberValid && (this.towns() === null || draft.townIds.length > 0);
  });

  cancel() {
    this.draft.reset();
    this.edit.set(false);
    this.cancelled.emit();
  }

  submit() {
    if (this.isValid() && !this.saving()) this.save.emit(this.draft.value());
  }
}
